var _g, _circle, _path, _circle2, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReddit48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,91c-21.505,0-39-17.495-39-39s17.495-39,39-39s39,17.495,39,39S73.505,91,52,91z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 44,
    fill: "#f2f2f2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#40396e",
    d: "M50,89c-21.505,0-39-17.495-39-39s17.495-39,39-39s39,17.495,39,39S71.505,89,50,89z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 37.5,
    fill: "#ef8630"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#40396e",
    d: "M50,89c-21.505,0-39-17.495-39-39s17.495-39,39-39s39,17.495,39,39S71.505,89,50,89z M50,14 c-19.851,0-36,16.149-36,36s16.149,36,36,36s36-16.149,36-36S69.851,14,50,14z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M76.016,50c0-3.165-2.56-5.678-5.678-5.678c-1.536,0-2.932,0.605-3.956,1.582 c-3.909-2.792-9.261-4.607-15.218-4.84l2.606-12.193l8.47,1.815c0.093,2.141,1.862,3.863,4.049,3.863 c2.234,0,4.049-1.815,4.049-4.049c0-2.234-1.815-4.049-4.049-4.049c-1.582,0-2.979,0.931-3.63,2.28l-9.447-2.001 c-0.279-0.047-0.558,0-0.745,0.14c-0.233,0.14-0.372,0.372-0.419,0.652l-2.885,13.59c-6.05,0.186-11.495,2.001-15.451,4.84 c-1.024-0.977-2.42-1.582-3.956-1.582c-3.165,0-5.678,2.56-5.678,5.678c0,2.327,1.396,4.282,3.351,5.166 c-0.093,0.558-0.14,1.117-0.14,1.722c0,8.749,10.192,15.87,22.758,15.87s22.758-7.074,22.758-15.87c0-0.558-0.047-1.163-0.14-1.722 C74.619,54.328,76.016,52.327,76.016,50z M37.016,54.049c0-2.234,1.815-4.049,4.049-4.049c2.234,0,4.049,1.815,4.049,4.049 c0,2.234-1.815,4.049-4.049,4.049C38.831,58.144,37.016,56.283,37.016,54.049z M59.68,64.8c-2.792,2.792-8.098,2.979-9.634,2.979 c-1.582,0-6.888-0.233-9.634-2.979c-0.419-0.419-0.419-1.07,0-1.489c0.419-0.419,1.07-0.419,1.489,0 c1.769,1.769,5.492,2.374,8.144,2.374c2.653,0,6.422-0.605,8.144-2.374c0.419-0.419,1.07-0.419,1.489,0 C60.053,63.729,60.053,64.381,59.68,64.8z M58.936,58.144c-2.234,0-4.049-1.815-4.049-4.049s1.815-4.049,4.049-4.049 s4.049,1.815,4.049,4.049C62.984,56.283,61.169,58.144,58.936,58.144z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit48);
export default __webpack_public_path__ + "static/media/reddit-48.cfedee3ac3033df49955c7e41074c657.svg";
export { ForwardRef as ReactComponent };